/** @format */

import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconAlertInfoFill,
  homefieldIconAlertWarningFill,
} from '@dsg-tech/homefield-angular-icons';

import { AlertMessageComponent } from './alert-message.component';
import { CommonModule } from '@angular/common';
import { BypassSanitizationPipe } from '@shared/utils/pipes';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [AlertMessageComponent],
  imports: [CommonModule, HomefieldIconLibraryModule, BypassSanitizationPipe],
  exports: [AlertMessageComponent],
})
export class AlertMessageModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([
      homefieldIconAlertInfoFill,
      homefieldIconAlertWarningFill,
    ]);
  }
}
